app.controller('modalEWaybillPrintSettingsCtrl', function ($scope, $uibModalInstance, urlServices, toaster, params) {
    $scope.data = angular.extend({
        maxPrintCount: 2,
        allowReprint: true,
        requireReprintAuthority: true,
        requireReprintReason: true,
        tokenExpiryMinutes: 5,
        showReprintWatermark: true,
        previewPrintLock: true
    }, params && params.settings ? params.settings : {});

    $scope.save = function () {
        var payload = {
            maxPrintCount: $scope.data.maxPrintCount,
            allowReprint: $scope.data.allowReprint ? 1 : 0,
            requireReprintAuthority: $scope.data.requireReprintAuthority ? 1 : 0,
            requireReprintReason: $scope.data.requireReprintReason ? 1 : 0,
            tokenExpiryMinutes: $scope.data.tokenExpiryMinutes,
            showReprintWatermark: $scope.data.showReprintWatermark ? 1 : 0,
            previewPrintLock: $scope.data.previewPrintLock ? 1 : 0
        };

        urlServices.updateData('api/e-waybill/print-settings', payload, function (err, result) {
            if (err) {
                return toaster.pop('error', 'E-Waybill', err.err || err || 'Gagal menyimpan setting print e-waybill');
            }
            toaster.pop('success', 'E-Waybill', 'Setting print e-waybill disimpan');
            $uibModalInstance.close(result || $scope.data);
        });
    };
});
